<h2>NS1200 (NS: 1954 - 1997)</h2>

<apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart" [fill]="chartOptions.fill" [grid]="chartOptions.grid"
  [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions" [xaxis]="chartOptions.xaxis" [yaxis]="chartOptions.yaxis"
  [title]="chartOptions.title" [tooltip]="chartOptions.tooltip"></apx-chart>
